<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :apiUrl="apiUrl"
      withoutDelete>

      <template #additionalButton>
        <button
          class="btn btn-sm btn-primary btn-icon-split"
          v-b-tooltip.hover
          :disabled="!selectedItem"
          title="Distribusikan"
          @click="distributeItem">
          <span class="icon">
            <i class="fas fa-dolly" />
          </span>
          <span class="text d-none d-lg-inline-block">Distribusikan</span>
        </button>

        <button
          class="btn btn-sm btn-danger btn-icon-split"
          v-b-tooltip.hover
          :disabled="!selectedItem"
          title="PenguranganPemakaian"
          @click="reduceItem">
          <span class="icon">
            <i class="fas fa-minus" />
          </span>
          <span class="text d-none d-lg-inline-block">Pemakaian</span>
        </button>

        <button
          class="btn btn-sm btn-secondary btn-icon-split"
          v-b-tooltip.hover
          :disabled="!selectedItem"
          title="Selisih barang"
          @click="openModalStockDiff">
          <span class="icon">
            <i class="fas fa-minus" />
          </span>
          <span class="text d-none d-lg-inline-block">Selisih Barang</span>
        </button>
      </template>
    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      :filter="scopedFilterData"
      @onSelectItem="selectedItem = $event"
      @onDblClicked="item => distributeItem(item)" />

    <b-modal id="modalDistribute" hide-footer no-close-on-backdrop title="Distribusi barang" header-class="bg-light text-primary py-1">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Ruang</label>
        <div class="col-sm-9">
          <v-select
            v-model="formDistribute.DepartmentID"
            :options="listDepartments"
            :reduce="item => item.ID"
            label="Name"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Tanggal, Pukul</label>
        <div class="col-sm-6">
          <b-form-datepicker v-model="currentDate" locale="id" size="sm" :max="new Date()" />
        </div>
        <div class="col-sm-3">
          <b-form-timepicker v-model="currentTime" locale="id" size="sm"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Jumlah</label>
        <div class="col-sm-9">
          <!-- <b-form-spinbutton size="sm" v-model.number="formDistribute.Quantity "min="1" :max="maxItem" /> -->

          <div class="input-group">
            <input
              type="number"
              min="1"
              class="form-control"
              v-model.number="formDistribute.Quantity"
              @keypress="$helper.inputRestrictNumber($event, formDistribute.Quantity, maxItem)" />

            <div class="input-group-prepend">
              <div class="input-group-text">
                {{ itemUnit.name }} 
              </div>
            </div>

            <button
              class="btn btn-sm btn-outline-primary"
              v-b-tooltip.hover
              title="Tukar Satuan"
              @click="exchangeUnit">
              <i class="fas fa-exchange-alt" />
            </button>
          </div>
            
        </div>
      </div>

      <div class="text-right">
        <button class="btn btn-sm btn-primary" @click="onSubmitDistribute" :disabled="isLoading || !formDistribute.DepartmentID">
          <b-spinner small v-show="isLoading" /> Kirim
        </button>
      </div>
    </b-modal>

    <b-modal id="modalReduce" hide-footer no-close-on-backdrop title="Pengurangan Barang" header-class="bg-light text-primary py-1">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Alasan</label>
        <div class="col-sm-9">
          <v-select
            v-model="formReduce.LogisticReductionTypeID"
            :options="listReductionTypes"
            :reduce="item => item.ID"
            disabled
            label="Name"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Tanggal, Pukul</label>
        <div class="col-sm-6">
          <b-form-datepicker v-model="currentDate" locale="id" size="sm" :max="new Date()" />
        </div>
        <div class="col-sm-3">
          <b-form-timepicker v-model="currentTime" locale="id" size="sm"/>
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">Jumlah</label>
        <div class="col-sm-9">

          <div class="input-group">
            <input
              type="number"
              min="1"
              class="form-control"
              v-model.number="formReduce.Quantity"
              @keypress="$helper.inputRestrictNumber($event, formDistribute.Quantity, maxItem)" />

            <div class="input-group-prepend">
              <div class="input-group-text">
                {{ itemUnit.name }} 
              </div>
            </div>

            <button
              class="btn btn-sm btn-outline-primary"
              v-b-tooltip.hover
              title="Tukar Satuan"
              @click="exchangeUnit">
              <i class="fas fa-exchange-alt" />
            </button>
          </div>

        </div>
      </div>

      <div class="text-right">
        <button class="btn btn-primary btn-sm" @click="onSubmitReduce" :disabled="isLoading || !formReduce.LogisticReductionTypeID">OK</button>
      </div>
    </b-modal>

    <b-modal id="modalStockDiff" hide-footer no-close-on-backdrop size="lg" title="Cetak Berita Acara Selisih Barang" header-class="bg-light text-primary py-1">
      <LogisticStockDiff :item="selectedItem" />
    </b-modal>

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

import LogisticStockDiff from '@/components/logistic/stock-diff.vue'

export default {
  components: { AppToolbox, AppTable, LogisticStockDiff },
  mounted() {
    this.fetchOptionData()

    this.scopedFilterData.departmentId = this.userDepartmentId
  },
  data() {
    return {
      apiUrl: '/logistic-stock',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'LogisticItem', label: 'Barang', formatter: value => value.Name },
        // { key: 'Quantity', label: 'Stok' },
        { key: 'ItemUnit', label: 'Jumlah', formatter: (value, key, item) => {

          let stock = item.Quantity + ' ' + item.LogisticItem.LogisticItemUnit.DistributionUnit

          if (item.LogisticItem.LogisticItemUnit.Ratio !== 1) {
            stock += ` (${item.Quantity / item.LogisticItem.LogisticItemUnit.Ratio} ${item.LogisticItem.LogisticItemUnit.Unit})`
          }

          return stock
        }},
        // { key: 'ItemPrice', label: 'Harga Pokok', formatter: (value, key, item) => {
        //   return this.$helper.formatRupiah(item.LogisticItem.Price)
        // }}
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {},
      scopedDetailData: {},
      listDepartments: [],
      listReductionTypes: [],
      currentDate: (new Date()).toISOString().slice(0,10),
      currentTime: (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':00',
      formDistribute: {
        DepartmentID: null,
        DateSent: null,
        Quantity: null
      },
      formReduce: {
        LogisticReductionTypeID: null,
        ReductionTime: null,
        Quantity: null
      },
      scopedFilterData: {
        departmentId: null
      },
      maxItem: 0,
      itemUnit: {
        isDistributeUnit: true,
        name: '',
        ratio: 1
      }
    }
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    },
    userDepartmentId () {
      return this.$store.getters['user/userDepartment'].ID
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/department'),
        this.$axios.get('/logistic-reduction-type')
      ]).then(this.$axios.spread((...res) => {
        this.listDepartments = res[0].data
        this.listReductionTypes = res[1].data
      }))
    },
    exchangeUnit () {
      if (this.itemUnit.isDistributeUnit) {
        this.itemUnit.name = this.selectedItem.LogisticItem.LogisticItemUnit.Unit
        this.itemUnit.ratio = this.selectedItem.LogisticItem.LogisticItemUnit.Ratio
        this.itemUnit.isDistributeUnit = false
      } else {
        this.itemUnit.name = this.selectedItem.LogisticItem.LogisticItemUnit.DistributionUnit
        this.itemUnit.ratio = 1
        this.itemUnit.isDistributeUnit = true
      }
    },
    distributeItem (item) {
      item = (item.constructor === Object) ? item : this.selectedItem

      this.selectedItem = item

      this.formDistribute.Quantity = 1
      this.formDistribute.DepartmentID = null

      this.formDistribute.LogisticItemID = item.LogisticItemID
      this.maxItem = item.Quantity

      this.itemUnit.isDistributeUnit = true
      this.itemUnit.name = item.LogisticItem.LogisticItemUnit.DistributionUnit
      this.itemUnit.ratio = 1

      this.$bvModal.show('modalDistribute')
    },
    reduceItem (item) {
      item = (item.constructor === Object) ? item : this.selectedItem

      this.formReduce.LogisticReductionTypeID = 1
      this.formReduce.Quantity = item.Quantity === 0 ? 0 : 1

      this.formReduce.LogisticItemID = item.LogisticItemID
      this.maxItem = item.Quantity

      this.itemUnit.isDistributeUnit = true
      this.itemUnit.name = item.LogisticItem.LogisticItemUnit.DistributionUnit
      this.itemUnit.ratio = 1

      this.$bvModal.show('modalReduce')
    },
    onSubmitDistribute () {
      if (!this.formDistribute.DepartmentID) {
        this.$store.commit('error/errorOccurred', 'Ruang tujuan tidak boleh kosong')
        return
      }

      if (this.formDistribute.DepartmentID === this.userDepartmentId) {
        this.$store.commit('error/errorOccurred', 'Tidak bisa distribusi ke ruang sendiri')
        return
      }

      if (this.formDistribute.Quantity < 1 || this.formDistribute.Quantity > this.maxItem) {
        this.$store.commit('error/errorOccurred', 'Jumlah melebihi stok')
        return
      }

      this.formDistribute.Quantity = this.formDistribute.Quantity * this.itemUnit.ratio

      this.formDistribute.DateSent = this.currentDate + ' ' + this.currentTime
      this.formDistribute.QuantityLimit = this.formDistribute.Quantity

      this.$axios.post('/logistic-distribution', this.formDistribute).then(res => {
        this.onRefresh()
        
        this.currentDate = (new Date()).toISOString().slice(0,10)
        this.currentTime = (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':00'

        this.itemUnit.isDistributeUnit = true
        this.itemUnit.name = this.selectedItem.LogisticItem.LogisticItemUnit.DistributionUnit
        this.itemUnit.ratio = 1

        this.$bvModal.hide('modalDistribute')

        this.$bvToast.toast('Berhasil dikirim', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      })
    },
    onSubmitReduce () {
      if (!this.formReduce.LogisticReductionTypeID) {
        this.$store.commit('error/errorOccurred', 'Alasan tidak boleh kosong')
        return
      }

      if (this.formReduce.Quantity < 1 || this.formReduce.Quantity > this.maxItem) {
        this.$store.commit('error/errorOccurred', 'Jumlah melebihi stok')
        return
      }

      this.formReduce.Quantity = this.formReduce.Quantity * this.itemUnit.ratio

      this.formReduce.ReductionTime = this.currentDate + ' ' + this.currentTime

      this.$axios.post('/logistic-reduction', this.formReduce).then(res => {
        this.onRefresh()

        this.currentDate = (new Date()).toISOString().slice(0,10)
        this.currentTime = (new Date()).getHours() + ':' + (new Date()).getMinutes() + ':00'

        this.itemUnit.isDistributeUnit = true
        this.itemUnit.name = this.selectedItem.LogisticItem.LogisticItemUnit.DistributionUnit
        this.itemUnit.ratio = 1

        this.$bvModal.hide('modalReduce')

        this.$bvToast.toast('Berhasil', {
          title: 'Sukses!!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-bottom-right',
          appendToast: true
        })
      })
    },
    openModalStockDiff () {
      this.$bvModal.show('modalStockDiff')
    }
  }
}
</script>
